import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { PricingState } from "../pricingSlice";
import { addContractPricingReducers } from "./contractPricingReducers";
import { addCreateQuoteReducers } from "./createQuoteReducers";
import { addFetchFunnelsReducers, addFetchFunnelsByGuaranteesReducers, addFetchFunnelsByVariableOrFeesReducers } from "./fetchFunnelsReducers";

export const extraReducers = (builder: ActionReducerMapBuilder<PricingState>) => {
  addFetchFunnelsReducers(builder);
  addFetchFunnelsByGuaranteesReducers(builder);
  addFetchFunnelsByVariableOrFeesReducers(builder);
  addContractPricingReducers(builder);
  addCreateQuoteReducers(builder);
};
